import { Box, CircularProgress } from "@material-ui/core";
import * as React from "react";

import theme from "@/theme";

// 表示までの待ち時間。これより早く終わる通信ではスピナーを出さず、一瞬の点滅を防ぐ
const DEFAULT_DELAY_MS = 300;

type LoadingOverlayProps = {
  open: boolean;
  delayMs?: number;
};

/**
 * 通信中に画面を覆って操作を止めるオーバーレイ。
 * 背後の内容が見えたままになるため、失敗して戻ってきたときに入力が消えたように見えない。
 */
export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ open, delayMs = DEFAULT_DELAY_MS }) => {
  const [isVisible, setIsVisible] = React.useState(false);

  React.useEffect(() => {
    if (!open) {
      setIsVisible(false);
      return;
    }
    const timeoutId = window.setTimeout(() => setIsVisible(true), delayMs);
    return () => window.clearTimeout(timeoutId);
  }, [open, delayMs]);

  if (!isVisible) return null;

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      position="fixed"
      top={0}
      left={0}
      width="100%"
      height="100%"
      bgcolor="rgba(0, 0, 0, 0.5)"
      zIndex={theme.zIndex.modal}
    >
      <CircularProgress />
    </Box>
  );
};

export default LoadingOverlay;
